import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const advIcons = {
  contact: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" className="h-6 w-6">
      <path d="M16 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="10" cy="7" r="4" /><path d="M18 8v6M21 11h-6" />
    </svg>
  ),
  react: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" className="h-6 w-6">
      <path d="M13 2 3 14h7l-1 8 10-12h-7l1-8Z" />
    </svg>
  ),
  transparency: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" className="h-6 w-6">
      <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7Z" /><circle cx="12" cy="12" r="3" />
    </svg>
  ),
  code: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" className="h-6 w-6">
      <path d="m8 6-6 6 6 6M16 6l6 6-6 6" />
    </svg>
  ),
};

const HeroAbout = () => {
    const { t } = useTranslation();

    const advantages = [
        { icon: advIcons.contact, title: t('about.adv1Title'), text: t('about.adv1Text') },
        { icon: advIcons.react, title: t('about.adv2Title'), text: t('about.adv2Text') },
        { icon: advIcons.transparency, title: t('about.adv3Title'), text: t('about.adv3Text') },
        { icon: advIcons.code, title: t('about.adv4Title'), text: t('about.adv4Text') },
    ];

    return (
        <div className="relative hero-surface" id="heroAbout">
            <div className="pointer-events-none absolute inset-x-0 top-0 h-[480px] grid-mask" />
            <div className="container-x relative pt-32 pb-16 lg:pt-44 lg:pb-24">
                <div className="max-w-3xl mx-auto text-center" data-aos="fade-up">
                    <span className="eyebrow justify-center">
                        <span className="h-1.5 w-1.5 rounded-full bg-brand-500" />
                        {t('ui.eyebrowAbout')}
                    </span>
                    <h1 className="mt-5 text-4xl md:text-5xl xl:text-6xl font-extrabold leading-[1.1] text-ink">
                        {t('heroAbout.title')}
                    </h1>
                    <p className="mt-6 text-lg text-slatex-600">
                        {t('heroAbout.description')}
                    </p>
                    <div className="mt-8 flex flex-col sm:flex-row justify-center gap-3">
                        <Link to="/services" className="btn-primary">
                            {t('heroAbout.learnMore')}
                            <svg className="w-4 h-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd" /></svg>
                        </Link>
                        <Link to="/contact" className="btn-secondary">{t('ui.getInTouch')}</Link>
                    </div>
                </div>

                <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-aos="fade-up" data-aos-delay="150">
                    {advantages.map((a) => (
                        <div key={a.title} className="rounded-2xl border border-slatex-200 bg-white/70 backdrop-blur p-6 shadow-soft">
                            <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-brand-50 text-brand-600">
                                {a.icon}
                            </span>
                            <h3 className="mt-4 text-base font-bold text-ink font-display">{a.title}</h3>
                            <p className="mt-2 text-sm leading-relaxed text-slatex-600">{a.text}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default HeroAbout;
